import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-amd",
  "use": "oc-amd-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"oc-amd\"><defs><style type=\"text/css\"></style></defs><path d=\"M745.364775 278.683476H288.269403L9.634178 0H1024v1014.403351l-278.635225-278.651309zM287.942366 736.079079V334.526325L1.072251 621.374995v401.574199h401.499142l286.854031-286.870115z\" fill=\"#00A76D\" p-id=\"3040\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol